'use strict';

import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
export default {
    mixins: [
        BaseVueComponent
    ],
    data() {
        return {
            statNumber: [],
            observer: null
        }
    },
    methods: {
        easeOutCubic(time) {
            return (--time) * time * time + 1;
        },
        formatNumber(value, decimals) {
            const lang = document.documentElement.lang;

            return value.toLocaleString(lang, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        },
        countDecimals(value) {
            if (Math.floor(value) === value) {
                return 0;
            }

            return value.toString().split(".")[1].length || 0;
        },
        incrementValue(el, end, decimals) {
            const start = 0;
            const duration = parseInt(el?.dataset?.statAnimationDuration) || 3500;
            let startTimestamp = null;

            const step = (timestamp) => {
                if (!startTimestamp) {
                    startTimestamp = timestamp;
                }

                const elapsedPercent = (timestamp - startTimestamp) / duration;
                const easedProgress = Math.min(this.easeOutCubic(elapsedPercent), 1);
                const numberInProgress = Math.abs(easedProgress * (end - start) + start);

                el.innerHTML = this.formatNumber(numberInProgress, decimals);

                if (easedProgress < 1) {
                    window.requestAnimationFrame(step);
                }
            };

            window.requestAnimationFrame(step);
        },
        intersectionObserver(statisticElement) {
            this.statNumber = statisticElement.querySelectorAll("[data-stat-number]");
            const observerOptions = {
                root: null,
                rootMargin: "0px 0px",
                threshold: 0
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const statistic = entry.target?.dataset?.statNumberInvariant.replace(/,/g, "");
                        const number = parseFloat(statistic);
                        const decimals = this.countDecimals(number);

                        this.incrementValue(entry.target, number, decimals);
                        this.observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
        },
        initStatisticAnimation(statisticElement) {
            this.intersectionObserver(statisticElement);

            if (this.statNumber.length > 0) {
                this.statNumber.forEach((el) => {
                    this.observer.observe(el);
                });
            }
        }
    },
    mounted() {
        const getStatisticAnimationElement = [...this.$el.querySelectorAll('[data-enable-statistic-animation]')];

        for(const element of getStatisticAnimationElement) {
            const startAnimation =  element?.dataset?.enableStatisticAnimation === 'true';

            if(startAnimation) {
                this.initStatisticAnimation(element);
            }
        }
    }
};